module.exports = __webpack_public_path__ + "img/capa1.4769c7a8.webp";